<template>

    <div class="container">
        <header-com />
        <header class="header">
            <div class="title-ds">
                评价
            </div>
            <div class="submit">
                <span>提交</span>
            </div>
        </header>
        <div class="main-panel">
            <div>
                <div class="title">
                    <span class="name">
                        客服
                    </span>
                    <img src="/images/order/start.png" alt="" class="start">
                    <img src="/images/order/start.png" alt="" class="start">
                    <img src="/images/order/start.png" alt="" class="start">
                    <img src="/images/order/start.png" alt="" class="start">
                    <img src="/images/order/nostart.png" alt="" class="start">
                    <span class="start-disc">
                        非常好
                    </span>
                </div>
                <div class="title">
                    <span class="name">
                        客服
                    </span>
                    <img src="/images/order/start.png" alt="" class="start">
                    <img src="/images/order/start.png" alt="" class="start">
                    <img src="/images/order/start.png" alt="" class="start">
                    <img src="/images/order/start.png" alt="" class="start">
                    <img src="/images/order/nostart.png" alt="" class="start">
                    <span class="start-disc">
                        非常好
                    </span>
                </div>
                <div class="title">
                    <span class="name">
                        客服
                    </span>
                    <img src="/images/order/start.png" alt="" class="start">
                    <img src="/images/order/start.png" alt="" class="start">
                    <img src="/images/order/start.png" alt="" class="start">
                    <img src="/images/order/start.png" alt="" class="start">
                    <img src="/images/order/nostart.png" alt="" class="start">
                    <span class="start-disc">
                        非常好
                    </span>
                </div>
            </div>
            <div class="no-name-dfe">
                <span>
                    匿名评价
                </span>
                <img src="/images/order/no-name.png" style="width: 10px;height: 10px;position: relative;top: 2px;" alt="">
            </div>
        </div>
       
        <div class="width:100%;margin-top:50px">
            
        </div>
    </div>
</template>

<script>
  import orderApi from '@/axios/order'
  import { Toast } from 'vant';

  import publicObj from '@/assets/js/public';
  import QRCode from 'qrcode';
  export default {
    name: 'evaluate',
    components : {

    },
    data () {
      return {
      }
    },
    computed: {
     
    },
    created () {
     
    },
    mounted () {
        
    },
    methods: {   
      getDetail(id){
      
      }
    }
  }
</script>

<style scoped lang="scss">
.container{
    background-color:rgba(247, 247, 247, 1);
    padding: 0 0 50px 0;
    min-height: 1800px;
}
.header{
    background-color: #fff;
}
.title-ds{
    text-align: center;
    height: 100px;
    font-size: 30px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #000000;
    line-height: 100px;
}
  .title{
    height: 100px;
    font-size: 30px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #000000;
    line-height: 100px;
  }
  .submit{
    width: 110px;
    height: 56px;
    text-align: center;
    line-height: 56px;
    background: #6DDEDE;
    border-radius: 4px;
    position: absolute;
    right: 24px;
    top: 24px;
    span{
        color:#fff;
    }
  }
  .main-panel{
      background-color: #fff;
      margin: 24px;
      width: calc(100% - 96px);
      padding:24px;
  }
  .start{
    width: 40px;
    height: 38px; 
    position: relative;
    top: 4px;
    margin:0 10px;
    // vertical-align:middle;
  }
  .name{
    font-size: 28px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 800;
    color: #1A1A1A;
    line-height: 20px;
    margin-right:100px;
  }
  .start-disc{
    float: right;
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
  }
  .start-tag{
    margin:10px 20px;
    padding: 5px 10px;
    height: 40px;
    background: #F5F5F5;
    border-radius: 4px;
  }
  .van-tag{
      padding: 5px 10px;
      margin: 10px 20px;
      background-color:rgba(245, 245, 245, 1)!important;
      color: rgba(102, 102, 102, 1)!important;
  }
  .bu-disc{
    width: calc(100% - 40px);
    height: 280px;
    background: #F7F7F7;
    border-radius: 4px;
    padding: 20px;
  }
  .text-fuck{
    font-size: 0.32rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    position: relative;
    left:calc(100% - 90px);
    top:-50px;
  }
.no-name-dfe{
    text-align: right;
    position: relative;
    top: -14px;
    font-size:10px
}
</style>
